import type { MenuProps } from "antd";
type MenuItem = Required<MenuProps>["items"][number];
import {
  ApiOutlined,
  DollarCircleOutlined,
  ShopOutlined,
  ToolOutlined,
  TruckOutlined,
  AppstoreOutlined,
  ScissorOutlined,
} from "@ant-design/icons";
import { KeyRound } from "@/components";

type MenuItemWithList = Omit<MenuItem, "children"> & {
  name?: string;
  list?: string;
  items?: MenuItemWithList[];
  key?: string;
  label?: string;
  type?: string;
  meta?: {};
};

/**
 * ¿Ve Apps → Optimizer de ESTE seller? (xcons-docs#524)
 *
 * `optimizer_config` es binario y arranca en Sin acceso: sólo lo ve quien lo tenga concedido.
 * Se saca del array en vez de esconderse con `CanAccess`: este admin no
 * tiene `accessControlProvider` y `CanAccess` deja pasar todo. El backend rechaza igual.
 */
const veOptimizador = (identity: any, sellerCode: string): boolean => {
  const nivel = String(
    identity?.permissions?.seller?.optimizer_config?.[sellerCode] ??
      "no_access",
  )
    .trim()
    .toLowerCase();

  return nivel !== "no_access";
};

export const ResourcesSellers = (t: any, identity?: any) => {
  const sellerLinkStorage =
    localStorage.getItem("smartMenuName")?.replace(/"/g, "").toLowerCase() ??
    "";
  const sellerLink = encodeURIComponent(sellerLinkStorage);

  const resourcesOrders: MenuItemWithList[] = [
    {
      key: `sellers/linked-products`,
      name: `sellers/linked-products`,
      list: `sellers/linked-products/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.linked"),
        icon: <ApiOutlined />,
      },
    },
    // {
    //   key: `sellers/logistics`,
    //   name: `sellers/logistics`,
    //   list: `sellers/logistics/${sellerLink}`,
    //   meta: {
    //     label: t("smartMenu.label.logistics"),
    //     icon: <TruckOutlined />,
    //   },
    // },
    // {
    //   key: "sellers/payments",
    //   name: "sellers/payments",
    //   list: `sellers/payments/${sellerLink}`,
    //   meta: {
    //     label: t("smartMenu.label.payments"),
    //     icon: <DollarCircleOutlined />,
    //   },
    // },
    {
      key: "sellers/linked-stores",
      name: "sellers/linked-stores",
      list: `sellers/linked-stores/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.linkedStores"),
        icon: <ShopOutlined />,
      },
    },
    {
      key: "sellers/shipping-config",
      name: "sellers/shipping-config",
      list: `sellers/shipping-config/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.shippingConfig", "Envíos"),
        icon: <TruckOutlined />,
      },
    },
    {
      key: "sellers/payment-config",
      name: "sellers/payment-config",
      list: `sellers/payment-config/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.paymentConfig", "Pagos"),
        icon: <DollarCircleOutlined />,
      },
    },
    // {
    //   key: "sellers/applications",
    //   name: "sellers/applications",
    //   meta: {
    //     label: t("smartMenu.storeLabel.applications"),
    //     icon: <AppstoreOutlined />,
    //   },
    //   items: [
    //     {
    //       key: "sellers/cash-payment",
    //       list: `sellers/cash-payment/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.cash"),
    //       },
    //     },
    //     {
    //       key: "sellers/bank-transfer",
    //       list: `sellers/bank-transfer/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.bank-transfer"),
    //       },
    //     },
    //     {
    //       key: "sellers/echeq-payment",
    //       list: `sellers/echeq-payment/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.echeq-payment"),
    //       },
    //     },
    //     {
    //       key: "sellers/mercado-pago",
    //       list: `sellers/mercado-pago/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.mercado-pago"),
    //       },
    //     },
    //     {
    //       key: "sellers/fiserv",
    //       list: `sellers/fiserv/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.fiserv"),
    //       },
    //     },
    //     {
    //       key: "sellers/erp-api",
    //       list: `sellers/erp-api/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.erp-api"),
    //       },
    //     },
    //     {
    //       key: "sellers/getnet",
    //       list: `sellers/getnet/${sellerLink}`,
    //       meta: {
    //         label: t("smartMenu.label.getnet"),
    //       },
    //     },
    //   ],
    // },
    ...(veOptimizador(identity, sellerLinkStorage)
      ? [
          {
            key: "sellers/apps",
            name: "sellers/apps",
            meta: {
              label: t("smartMenu.label.apps", "Aplicaciones"),
              icon: <AppstoreOutlined />,
            },
            items: [
              {
                key: "sellers/optimizer",
                name: "sellers/optimizer",
                list: `sellers/optimizer/${sellerLink}`,
                meta: {
                  label: t("smartMenu.label.optimizer", "Optimizador"),
                  icon: <ScissorOutlined />,
                },
              },
            ],
          },
        ]
      : []),
    {
      key: `sellers/operators`,
      name: `sellers/operators`,
      list: `sellers/operators/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.sellerOperator"),
        icon: <KeyRound />,
      },
    },
    {
      key: `sellers/settings`,
      name: `sellers/settings`,
      list: `sellers/settings/${sellerLink}`,
      meta: {
        label: t("smartMenu.label.sellerSettings"),
        icon: <ToolOutlined />,
      },
    },
  ];

  return resourcesOrders;
};
